{
  "name": "@ns/support-companies-house-not-found",
  "version": "1.0.0",
  "description": "The live Companies House register does not have a company's number, so its Companies House trust score could not be calculated: nodeStream support re-checks it or finds out why, and resolves the card, or suppresses the score through trust-score/suppress",
  "inputs": {
    "subjectCompanyId": {
      "type": "string"
    },
    "subjectCompanyName": {
      "type": "string"
    },
    "companyNumber": {
      "type": "string"
    }
  },
  "outcomes": {
    "resolved": {
      "inputs": {
        "notes": {
          "type": "string"
        }
      }
    },
    "suppressed": {
      "inputs": {
        "notes": {
          "type": "string"
        }
      }
    }
  }
}
